module.exports = __webpack_public_path__ + "assets/img/27_1619_big.9710f3e8.jpg";